import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col" }
const _hoisted_2 = { class: "flex top-0 w-auto" }
const _hoisted_3 = { class: "flex flex-col overflow-auto items-center p-2 h-[100%]" }
const _hoisted_4 = { class: "flex flex-col bottom-0 text-white" }

import FooterComponent from "@/components/shared/footer/FooterComponent.vue";
import NavbarComponent from "@/components/shared/navigation/NavbarComponent.vue";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showInstallButton = ref(false);
const deferredPrompt = ref();

onMounted(() => {
  // Verifica se l'app è già stata installata come PWA
  if (! isAppInstalled() ) {
    // Aggiungi un ascoltatore per verificare quando l'utente ha effettuato l'installazione dell'app come PWA
    window.addEventListener("beforeinstallprompt", (event: Event) => {
      event.preventDefault(); // Previeni il prompt di installazione predefinito del browser
      deferredPrompt.value = event; // Salva il prompt deferred nell'istanza Vue
      // Mostra il pulsante "Installa app"
      showInstallButton.value = true;
    });

    window.addEventListener("appinstalled", () => {
      // L'utente ha completato con successo l'installazione dell'app come PWA, nascondi il pulsante "Installa app"
      showInstallButton.value = false;
    });
  }
});

const isAppInstalled = () => {
    return window.matchMedia('(display-mode: standalone)').matches ||
      document.referrer.includes('android-app://');
}

const installPwa = () => {
  const promptEvent = deferredPrompt.value;

  if (promptEvent) {
    promptEvent.prompt();

    promptEvent.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === "accepted") {
        console.log("L'utente ha accettato l'installazione");
      } else {
        console.log("L'utente ha rifiutato l'installazione");
      }

      deferredPrompt.value = null;
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast, { message: "" }),
    (showInstallButton.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "w-full bg-green-700 text-white",
          onClick: installPwa
        }, "Installa l'app"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NavbarComponent)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(FooterComponent)
    ])
  ]))
}
}

})